<template>
  <div>
    <ul class="chat__contacts bordered-items">
      <li class="cursor-pointer" v-for="(table, index) in nameTables" :key="index" @click="getRecords(connectionID, table)">
        <div class="chat__contact">
          <div class="chat__contact flex items-center px-2 pt-4 pb-2">
            <div class="contact__avatar mr-1">
              <feather-icon icon="GridIcon" svgClasses="h-5 w-5 ml-1" />
            </div>
            <div class="contact__container w-full flex items-center justify-between overflow-hidden">
              <div class="contact__info flex flex-col truncate w-full">
                <h5 class="font-semibold">{{ table }}</h5>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useConnStore } from "./store";
export default {
  methods: {
    ...mapActions(useConnStore, ["getRecords"]),    
  },
  computed: {
    ...mapState(useConnStore, ["nameTables", "connectionID", "activeSidebarRecords"])
  }
};
</script>

<style lang="scss" scoped></style>
